import { DefaultTheme } from 'styled-components';

import { defaultContainerStyles } from 'src/components/container/default-container-styles';
import { defaultParagraphPlaceholderStyles } from 'src/components/paragraph-placeholder/default-paragraph-placeholder-styles';

export const theme: DefaultTheme = {
  container: defaultContainerStyles,
  paragraphPlaceholder: defaultParagraphPlaceholderStyles,
};
